import { Interpolation } from "@emotion/core";
import { Colors } from "../../design-tokens/colors";
import { Border } from "../../design-tokens/borders";
import { grid } from "../../design-tokens/grid";
import { Device, DarkTheme } from "../../design-tokens/media-queries";
import { Fonts } from "../../design-tokens/fonts";
import { BoxShadow } from "../../design-tokens/box-shadow";

const root: Interpolation = {
  position: "relative",
  fontSize: "14px",
  lineHeight: "18px",
  backgroundColor: Colors.LightGrey,
  borderRadius: Border.Radius,
  padding: grid(2),
  paddingRight: grid(9.5),
  marginBottom: grid(4),
  boxShadow: BoxShadow.Default,

  [DarkTheme]: {
    backgroundColor: Colors.DarkModeBlack,
  },

  [Device.DesktopTablet]: {
    fontSize: "16px",
    lineHeight: "22px",
    paddingRight: grid(11.5),
    marginBottom: grid(4),
  },
};

const image: Interpolation = {
  position: "absolute",
  right: 5,
  bottom: 0,

  [DarkTheme]: {
    opacity: "0.95",
  },

  [Device.Mobile]: {
    width: 72,
  },
};

const heading: Interpolation = {
  fontWeight: Fonts.Weight.Bold,
  marginBottom: grid(1),
};

const styles = { root, image, heading };

export default styles;
